import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class WarehouseLocationService extends DatabaseGwService{

  URL_PATH: string = "/warehouse-locations";
}
